import { Skeleton, Stack, styled } from "@mui/material";
import { TextInput } from "../Form";
import { toPx } from "../MuiHelpers";
import { BodyTextM, HeadingM, HeadingXS } from "../Typography";

const TEXT_INPUT_WIDTH_PX = 88;
const CONTAINER_MD_UP_WIDTH_PX = 700;
const SKELETON_WIDTH_PX = 80;
const SLIDER_SKELETON_HEIGHT_PX = 14;

export const StackBetween = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    }),
);

export const MainWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(6),
        py: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: { md: toPx(CONTAINER_MD_UP_WIDTH_PX), xs: "100%" },
        mx: "auto",
    }),
);

export const SectionHeadingM = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(4),
    }),
);

export const SubHeadingM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(5),
    }),
);

export const NoMarginBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(0),
    }),
);

export const BoldBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: "bold",
    }),
);

export const SectionHeadingXS = styled(HeadingXS)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(0),
    }),
);

export const TextSMuted = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        color: theme.palette.grey[700],
    }),
);

export const FixedWidthTextInput = styled(TextInput)(({ theme }) =>
    theme.unstable_sx({
        width: toPx(TEXT_INPUT_WIDTH_PX),
    }),
);

export const SliderStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: theme.spacing(4),
        py: theme.spacing(4),
    }),
);

export const InlineBlockSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        display: "inline-block",
        width: toPx(SKELETON_WIDTH_PX),
    }),
);

export const SliderSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        height: toPx(SLIDER_SKELETON_HEIGHT_PX),
        my: theme.spacing(5),
    }),
);

export const EmployerSectionStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(5),
    }),
);
